import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SQUASH_AUDIO_BASE_URL } from './utils';

const intro = `${SQUASH_AUDIO_BASE_URL}/intro.mp3`;

const intro_audio = new Audio(intro);
intro_audio.loop = true;
intro_audio.volume = 0.2;

type SquashMuteState = {
  muted: boolean;
  setMuted: (muted: boolean) => void;
  playIntroAudio: () => void;
  stopIntroAudio: () => void;
};

export const useSquashMuteStore = create<SquashMuteState>()(
  persist(
    (set) => ({
      muted: false,
      setMuted: (muted: boolean) => set({ muted }),
      playIntroAudio: () => {
        intro_audio.play().catch(console.error);
      },
      stopIntroAudio: () => {
        intro_audio.pause();
        intro_audio.currentTime = 0;
      },
    }),
    {
      name: 'squash-mute-storage',
    }
  )
);

type SquashCompletedState = {
  completedCount: number;
  setCompletedCount: (count: number) => void;
};

export const useSquashCompletedStore = create<SquashCompletedState>()(
  persist(
    (set) => ({
      completedCount: 0,
      setCompletedCount: (count: number) => {
        set({ completedCount: count });
      },
    }),
    {
      name: 'squash-completed-storage',
    }
  )
);
